{
  "Clear search": "Suche zurücksetzen"
}
